import { NgModule } from '@angular/core';

import { RouterModule, Routes } from '@angular/router';

import { PaginaMainUserComponent } from './paginas/pagina-main-user/pagina-main-user.component';
import { PaginaMainCareComponent } from './paginas/pagina-main-care/pagina-main-care.component';
import { PaginaWelcomeComponent } from './paginas/pagina-welcome/pagina-welcome.component';
import { PaginaLoginAwsComponent } from './paginas/pagina-login-aws/pagina-login-aws.component';
import { PaginaMainMasterComponent } from './paginas/pagina-main-master/pagina-main-master.component';

const routes: Routes = [
  // { path: '/', component: PaginaLoginAwsComponent },
  { path: 'login-aws', component: PaginaLoginAwsComponent},
  { path: 'main-user/:id', component: PaginaMainUserComponent },
  { path: 'main-carer', component: PaginaMainCareComponent },
  { path: 'main-master', component: PaginaMainMasterComponent },
  { path: '', redirectTo: "login-aws", pathMatch: "full" } 
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }
